module.exports = __webpack_public_path__ + "img/068.870f1a4f.png";